module.exports = __webpack_public_path__ + "img/news-03.a3a07438.jpeg";